import { CHART_FEATURES } from './features';

/**
 * Series line colours for the history charts. With `CHART_FEATURES.pastelLinesDark` on, the
 * `--chart-*-line` tokens are used: identical to the strong tokens in the light theme, one to
 * two Tailwind stops lighter in the dark theme (see index.scss). Axis chrome keeps the strong tokens.
 */
const KEYS = ['wind', 'safe', 'caution', 'danger', 'temp', 'dew', 'cloud', 'pressure'];
export const LINE_COLORS = {
    ...Object.fromEntries(KEYS.map((k) => [k, `var(--chart-${k}${CHART_FEATURES.pastelLinesDark ? '-line' : ''})`])),
    // The two low wind bins reuse the rose's own tokens (already strong-in-light / pastel-in-dark).
    calm: 'var(--chart-rose-1)',
    light: 'var(--chart-rose-2)',
};
